import React from 'react'
import { Switch, Route } from 'react-router-dom'

import PersonListItem from './PersonListItem'
import Person from '../person'

const PersonListItemSwitch = ({person}) => (
  <Switch>
    <Route path={`/person/${person.id}`} render={props => <Person person={person} {...props} />} />
    <Route path="/" render={props => <PersonListItem person={person} {...props} />} />
  </Switch>
)

export default PersonListItemSwitch



// WEBPACK FOOTER //
// ./src/views/people/PersonListItemSwitch.js